import supabase from './database';

const normalizePath = (fullPath) => fullPath.replace(/^\/+/, '');

const parseStoragePath = (fullPath) => {
  const normalized = normalizePath(fullPath);
  const [bucket, ...rest] = normalized.split('/');
  const path = rest.join('/').replace(/^\/+/, '');
  if (!bucket) {
    throw new Error(`Invalid storage path: ${fullPath}`);
  }
  return { bucket, path };
};

const toFullPath = (bucket, path) => {
  const prefix = path.replace(/^\/+/, '').replace(/\/+$/, '');
  return prefix ? `${bucket}/${prefix}` : bucket;
};

// Placeholder to keep signature compatibility with Firebase getStorage()
export const getStorage = () => supabase.storage;

// Firebase-like ref; returns the path string.
export const ref = (_storage, path) => path;

export const uploadBytes = async (...args) => {
  let fullPath;
  let file;

  // Support both uploadBytes(refPath, file) and uploadBytes(storage, refPath, file)
  if (args.length === 2) {
    [fullPath, file] = args;
  } else {
    [, fullPath, file] = args;
  }

  const { bucket, path } = parseStoragePath(fullPath);
  const { error } = await supabase.storage.from(bucket).upload(path, file, { upsert: true });
  if (error) throw error;
};

export const listAll = async (fullPath) => {
  const { bucket, path } = parseStoragePath(fullPath);
  const folder = path.replace(/\/+$/, '');
  const { data, error } = await supabase.storage.from(bucket).list(folder || '', { limit: 1000, offset: 0 });
  if (error) throw error;

  return {
    items: (data || []).map((item) => ({
      name: item.name,
      fullPath: toFullPath(bucket, `${folder ? `${folder}/` : ''}${item.name}`),
    })),
  };
};

export const getDownloadURL = async (...args) => {
  let fullPath = args.length === 1 ? args[0] : args[1];
  if (fullPath && typeof fullPath === 'object' && fullPath.fullPath) {
    fullPath = fullPath.fullPath;
  }
  const { bucket, path } = parseStoragePath(fullPath);
  const { data, error } = await supabase.storage.from(bucket).createSignedUrl(path, 3600);
  if (error) throw error;
  return data.signedUrl;
};

export const deleteObject = async (...args) => {
  let fullPath = args.length === 1 ? args[0] : args[1];
  if (fullPath && typeof fullPath === 'object' && fullPath.fullPath) {
    fullPath = fullPath.fullPath;
  }
  const { bucket, path } = parseStoragePath(fullPath);
  const { error } = await supabase.storage.from(bucket).remove([path]);
  if (error) throw error;
};

export default {
  getStorage,
  ref,
  uploadBytes,
  listAll,
  getDownloadURL,
  deleteObject,
};
